export const ACCEPTED_FILE_TYPES = ['.png', '.jpg', '.jpeg', '.pdf']

// 5 MB
export const MAX_FILE_SIZE = 5 * 1024 * 1024
